<template>
  <span
    v-b-tooltip
    :class="['badge d-flex', tagBgColor]"
    :title="showTooltip ? title : null"
    style="max-width:100%"
  >
    <div class="tag-text-wrapper text-truncate d-inline-block">
      <slot>{{ title }}</slot>
    </div>
    <span
      v-if="!noRemove"
      class="remove-button bi bi-x"
      @click="$emit('remove')"
    />
  </span>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    noRemove: Boolean,
    title: String,
    showTooltip: Boolean,
    tagBgColor: String
  }
}
</script>

<style lang="scss" scoped>
@import 'public/css/color-config.scss';

.remove-button {
  margin-right: -6px;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.25);
  }
}
.badge {
  margin: 2px;
  padding: 0.35em 0.65em;
  &.bg-primary {
    background-color: $base-color !important;
    color: white;
  }
}
</style>
